import {Theme} from '@lookiero/aurora';
import {Platform} from 'react-native';
import StyleSheet from 'react-native-extended-stylesheet';

const {space8, space10} = Theme.get();

export const style = StyleSheet.create({
  titleAndDescriptionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  cta: {
    marginTop: space8,
    marginBottom: Platform.OS === 'ios' || Platform.OS === 'android' ? space10 : 0,
  },
});
